module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_5010.b11cf62f.png";